import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import joi from 'joi';

import TextField from '@mui/material/TextField';

const Email = (props) => {
	const {
		disabled,
		errors,
		id,
		label,
		onInputChange,
		onInputFocus,
		...styleProps
	} = props;
	const { t } = useTranslation('inputs');

	const schemaDefinition = {};

	schemaDefinition[id] = joi
		.string()
		.email({ minDomainSegments: 2, tlds: { allow: ['com', 'net', 'io'] } })
		.allow(null, '');
	const schema = joi.object(schemaDefinition);

	const handleErrorText = () => {
		if (!errors?.[id]) {
			return null;
		}

		return errors[id];
	};

	const handleOnChange = (e) => {
		onInputChange(e.target.value, id, schema);
	};

	return (
		<TextField
			disabled={disabled}
			{...styleProps}
			name={id}
			label={label || t('email.value')}
			onChange={handleOnChange}
			onFocus={onInputFocus}
			size="small"
			placeholder={t('email.placeholder')}
			slotProps={{
				inputLabel: {
					shrink: true
				}
			}}
			helperText={handleErrorText()}
			error={!!errors?.email}
		/>
	);
};

Email.propTypes = {
	disabled: PropTypes.bool,
	errors: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
	id: PropTypes.string.isRequired,
	label: PropTypes.string,
	onInputChange: PropTypes.func,
	onInputFocus: PropTypes.func,
	required: PropTypes.bool
};

export default Email;
